/*****************************************************
AB - sep-q2-regalos
Regalos exclusivos como beneficio de suscripción (variante B).

El triggerLocation de Convert se emite desde layout/theme.liquid.

Qué hace:
  1. Espera a que Convert agregue la clase `ab-sub-gifts-b` al <body>.
  2. Mueve el componente dentro de <ul class="stayai-subscriptions">, justo
     después del <li> de la opción de suscripción, y le pone `is-placed`.
     La visibilidad depende de esa clase (ver assets/optimize-product.css),
     así que si el widget de Stay AI no existe el componente nunca se ve.
  3. Monta el carrusel de mobile (scroll-snap + dots) y el modal "Ver todo".
*****************************************************/

(function () {
  'use strict';

  var TEST_CLASS = 'ab-sub-gifts-b';
  var READY_CLASS = 'ab-sub-gifts-b--ready';
  var GOAL_VIEW_ALL_ID = '1004126301';
  var SUB_LABEL_SELECTOR = ".stayai-subscriptions [for='purchaseTypeSubscription']";

  /* ----------------------------------------------------------------
     Goal de Convert
  ---------------------------------------------------------------- */

  /*
    Goal de Convert: click en "Ver todo". El botón solo existe en la variante B
    —en el control el componente entero está oculto—, así que la conversión
    nunca se emite desde el original.
  */
  function pushGoalViewAll() {
    window._conv_q = window._conv_q || [];
    window._conv_q.push(['triggerConversion', GOAL_VIEW_ALL_ID]);
    console.log('GOAL - Click Ver Todo Regalos');
  }

  /* ----------------------------------------------------------------
     Gate de activación: nada corre hasta que Convert marca el <body>
  ---------------------------------------------------------------- */

  /*
    Atajo de QA: con ?ab_sub_gifts=1 en la URL se enciende la variante B sin
    pasar por Convert, para poder revisarla en el theme de desarrollo. No
    contamina la prueba: solo aplica si el parámetro viene en esa carga.
  */
  function previewRequested() {
    return window.location.search.indexOf('ab_sub_gifts=1') !== -1;
  }

  function whenActivated(callback) {
    if (previewRequested()) {
      document.body.classList.add(TEST_CLASS);
    }

    if (document.body.classList.contains(TEST_CLASS)) {
      callback();
      return;
    }

    var observer = new MutationObserver(function () {
      if (document.body.classList.contains(TEST_CLASS)) {
        observer.disconnect();
        callback();
      }
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* ----------------------------------------------------------------
     Colocación dentro del widget de Stay AI
  ---------------------------------------------------------------- */

  /*
    El Figma 578:152 pone la tarjeta de regalos DENTRO de la tarjeta azul de la
    suscripción, como último elemento. Esa tarjeta azul es
    .stayai-purchase-label__wrapper, que vive dentro del <label> del radio.

    Meter un <button> dentro de un <label> es seguro: el spec dice que el label
    no activa su control cuando el click cae en contenido interactivo, así que
    "Ver todo" no marca el radio.
  */
  function giftsContainer(scope) {
    var label = scope.querySelector(SUB_LABEL_SELECTOR);
    if (!label) return null;
    return label.querySelector('.stayai-purchase-label__wrapper') || label;
  }

  function placeAll() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-ab-sub-gifts]'));
    if (!nodes.length) return;

    // Agrupa por product-info para no mezclar el PDP con un quick view.
    var scopes = [];
    nodes.forEach(function (node) {
      var scope = node.closest('product-info') || document.body;
      var entry = scopes.filter(function (item) {
        return item.scope === scope;
      })[0];
      if (!entry) {
        entry = { scope: scope, nodes: [] };
        scopes.push(entry);
      }
      entry.nodes.push(node);
    });

    scopes.forEach(function (entry) {
      // Si el Section Rendering API repintó el bloque mientras ya había un
      // componente colocado, el duplicado sobra: se descarta.
      var placed = entry.nodes.filter(function (node) {
        return node.classList.contains('is-placed');
      });

      var target = giftsContainer(entry.scope);
      if (!target) return;

      var node;
      if (placed.length) {
        node = placed[0];
        entry.nodes.forEach(function (other) {
          if (other !== node) other.remove();
        });
      } else {
        node = entry.nodes[0];
        entry.nodes.forEach(function (other) {
          if (other !== node) other.remove();
        });
      }

      if (target.lastElementChild !== node) {
        target.appendChild(node);
      }

      node.classList.add('is-placed');
      initComponent(node);
    });
  }

  /* ----------------------------------------------------------------
     Carrusel de mobile
  ---------------------------------------------------------------- */

  function initCarousel(root) {
    var viewport = root.querySelector('[data-ab-gifts-viewport]');
    var track = root.querySelector('[data-ab-gifts-track]');
    var dotsWrap = root.querySelector('[data-ab-gifts-dots]');
    if (!viewport || !track || !dotsWrap) return;

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    dotsWrap.innerHTML = '';

    var dots = slides.map(function (slide, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ab-sub-gifts__dot';
      dot.setAttribute('aria-label', 'Regalo ' + (index + 1));
      dot.addEventListener('click', function () {
        viewport.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
      return dot;
    });

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function syncFromScroll() {
      var left = viewport.scrollLeft;
      var closest = 0;
      var smallest = Infinity;

      slides.forEach(function (slide, index) {
        var distance = Math.abs(slide.offsetLeft - track.offsetLeft - left);
        if (distance < smallest) {
          smallest = distance;
          closest = index;
        }
      });

      setActive(closest);
    }

    setActive(0);
    viewport.addEventListener('scroll', syncFromScroll, { passive: true });
  }

  /* ----------------------------------------------------------------
     Modal "Ver todo"
  ---------------------------------------------------------------- */

  var openModal = null;
  // El resize se escucha una sola vez; aquí vive el render del modal vigente,
  // para no acumular listeners cada vez que el PDP se repinta.
  var renderModalPage = null;

  /*
    Carrusel paginado del modal (Figma 578:2711 / 578:2785): 3 tarjetas por
    página en desktop y 2 en mobile, con flechas y dots. No hay scroll: el JS
    marca las tarjetas fuera de la página activa y el CSS las oculta.
  */
  function initModalCarousel(modal) {
    var track = modal.querySelector('[data-ab-gifts-modal-track]');
    var dotsWrap = modal.querySelector('[data-ab-gifts-modal-dots]');
    var prev = modal.querySelector('[data-ab-gifts-prev]');
    var next = modal.querySelector('[data-ab-gifts-next]');
    if (!track) return null;

    var slides = Array.prototype.slice.call(track.children);
    var page = 0;

    function perPage() {
      return window.matchMedia('(max-width: 749px)').matches ? 2 : 3;
    }

    function render() {
      var size = perPage();
      var total = Math.max(1, Math.ceil(slides.length / size));

      if (page > total - 1) page = total - 1;
      if (page < 0) page = 0;

      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-off-page', Math.floor(index / size) !== page);
      });

      if (dotsWrap) {
        if (dotsWrap.children.length !== total) {
          dotsWrap.innerHTML = '';
          for (var i = 0; i < total; i++) {
            dotsWrap.appendChild(buildDot(i));
          }
        }

        Array.prototype.forEach.call(dotsWrap.children, function (dot, index) {
          dot.classList.toggle('is-active', index === page);
        });

        dotsWrap.classList.toggle('is-hidden', total < 2);
      }

      if (prev) prev.disabled = page === 0;
      if (next) next.disabled = page >= total - 1;
    }

    function buildDot(index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ab-sub-gifts-modal__dot';
      dot.setAttribute('aria-label', 'Página ' + (index + 1));
      dot.addEventListener('click', function () {
        page = index;
        render();
      });
      return dot;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        page -= 1;
        render();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        page += 1;
        render();
      });
    }

    /*
      Swipe. Este carrusel no usa scroll (las páginas se muestran y se ocultan),
      así que el gesto no llega solo: hay que leerlo. Solo cuenta como swipe si
      el movimiento es claramente horizontal, para no robarle el scroll vertical
      al panel cuando la página es más alta que la pantalla.
    */
    var touchX = null;
    var touchY = null;

    track.addEventListener(
      'touchstart',
      function (event) {
        var touch = event.changedTouches[0];
        touchX = touch.clientX;
        touchY = touch.clientY;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchend',
      function (event) {
        if (touchX === null) return;

        var touch = event.changedTouches[0];
        var dx = touch.clientX - touchX;
        var dy = touch.clientY - touchY;
        touchX = null;
        touchY = null;

        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;

        page += dx < 0 ? 1 : -1;
        render();
      },
      { passive: true }
    );

    render();
    return render;
  }

  function closeModal() {
    if (!openModal) return;
    openModal.classList.remove('is-open');
    document.body.classList.remove('ab-sub-gifts-modal-open');
    openModal = null;
  }

  function initModal(root) {
    var modal = root.querySelector('[data-ab-gifts-modal]');
    var trigger = root.querySelector('[data-ab-gifts-open]');
    if (!modal || !trigger) return;

    // El componente vive dentro del widget de Stay AI, que está en columnas con
    // overflow y transform: un overlay fixed ahí dentro se recorta. Se cuelga
    // del <body> y se limpian los huérfanos de repintados anteriores.
    Array.prototype.slice
      .call(document.querySelectorAll('body > [data-ab-gifts-modal]'))
      .forEach(function (orphan) {
        if (orphan !== modal) orphan.remove();
      });

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    renderModalPage = initModalCarousel(modal);

    trigger.addEventListener('click', function () {
      /*
        Reasegurо el traslado en el momento que importa. Si el modal se queda
        dentro del widget, hereda el `text-align: center` del app block y su
        position:fixed queda atrapado por el transform que AOS le pone a
        product-info, así que el overlay no cubre la página.
      */
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      modal.classList.add('is-open');
      document.body.classList.add('ab-sub-gifts-modal-open');
      openModal = modal;

      pushGoalViewAll();
    });

    Array.prototype.slice.call(modal.querySelectorAll('[data-ab-gifts-close]')).forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    /*
      Click fuera del panel. El backdrop ya lleva data-ab-gifts-close, pero el
      contenedor del modal tiene 16px de padding propio: un click ahi cae en el
      contenedor y no en el backdrop. Se comprueba el target para no cerrar
      cuando el click viene de dentro del panel.
    */
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
  }

  /* ----------------------------------------------------------------
     Init por componente (idempotente)
  ---------------------------------------------------------------- */

  function initComponent(root) {
    if (root.dataset.abGiftsReady === '1') return;
    root.dataset.abGiftsReady = '1';
    initCarousel(root);
    initModal(root);
  }

  /* ----------------------------------------------------------------
     Reescritura del encabezado y los beneficios del widget de Stay AI

     Portado de la prueba subscription-frontend-discount (commit d530f7c),
     recortado a lo que pide el Figma de esta prueba. Lo que NO se trajo: la
     pastilla "MAYOR AHORRO", el beneficio de regalos (ahora es su propia
     tarjeta), el restyling del selector de frecuencia, el badge del modal de
     alta y el cupón PRIMERENTREGA — ese descuento era de aquella prueba, no
     de esta.
  ---------------------------------------------------------------- */

  var WIDGET_CFG = window.ABSubGiftsWidget;
  var WRAPPER_SELECTOR = "label[for='purchaseTypeSubscription'] .stayai-purchase-label__wrapper";
  var WIDGET_DONE_ATTR = 'data-ab-sub-gifts-widget';

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildIcon(src, className, size) {
    var img = document.createElement('img');
    img.className = className;
    img.src = src;
    img.alt = '';
    img.width = size;
    img.height = size;
    return img;
  }

  function rewriteLabel(wrapper) {
    var label = wrapper.querySelector('.subscription-label');
    if (!label) return;

    // rtx-pdp.js hace `savingLbl.textContent = …` sobre `.subscription-savings`
    // sin comprobar null (updateProductPrice). Si se borra ese nodo, el widget
    // revienta en cada cambio de variante o de plan: se conserva y solo se oculta.
    var savings = label.querySelector('.subscription-savings');
    if (!savings) {
      savings = document.createElement('span');
      savings.className = 'subscription-savings';
    }
    savings.classList.add('ab-subw__savings');

    label.textContent = '';

    var lead = document.createElement('span');
    lead.className = 'ab-subw__lead';
    lead.textContent = WIDGET_CFG.text.lead;
    label.appendChild(lead);

    var offer = document.createElement('span');
    offer.className = 'ab-subw__offer';
    offer.textContent = WIDGET_CFG.text.offer;
    label.appendChild(offer);

    if (WIDGET_CFG.icons.offer) {
      label.appendChild(buildIcon(WIDGET_CFG.icons.offer, 'ab-subw__offer-icon', 16));
    }

    label.appendChild(savings);
  }

  function rewriteDetails(wrapper) {
    var container = wrapper.querySelector('.stayai-subscription-details-container');
    if (!container) return;

    var list = document.createElement('ul');
    list.className = 'ab-subw__list';

    WIDGET_CFG.details.forEach(function (detail, index) {
      var item = document.createElement('li');
      item.className = 'ab-subw__item';

      if (detail.icon) {
        item.appendChild(buildIcon(detail.icon, 'ab-subw__item-icon', 24));
      }

      var text = document.createElement('span');
      text.className = 'ab-subw__item-text';
      text.setAttribute('data-ab-subw-detail', String(index));
      item.appendChild(text);

      list.appendChild(item);
    });

    container.textContent = '';
    container.appendChild(list);
  }

  // El % de ahorro lo escribe la app, así que se relee en cada pasada.
  function refreshDetailText(wrapper) {
    var node = wrapper.querySelector('.subscription-savings');
    var savings = node ? node.textContent.trim() : '';
    if (!savings) savings = WIDGET_CFG.fallbackSavings || '';

    WIDGET_CFG.details.forEach(function (detail, index) {
      var slot = wrapper.querySelector('[data-ab-subw-detail="' + index + '"]');
      if (!slot) return;

      var html = detail.html.replace(/\{savings\}/g, escapeHtml(savings));
      if (slot.innerHTML !== html) slot.innerHTML = html;
    });
  }

  function rewriteWidget() {
    if (!WIDGET_CFG) return;

    var wrappers = document.querySelectorAll(WRAPPER_SELECTOR);
    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      if (wrapper.getAttribute(WIDGET_DONE_ATTR) !== '1') {
        rewriteLabel(wrapper);
        rewriteDetails(wrapper);
        wrapper.setAttribute(WIDGET_DONE_ATTR, '1');
      }
      refreshDetailText(wrapper);
    }

    if (wrappers.length) document.body.classList.add(READY_CLASS);
  }

  /* ----------------------------------------------------------------
     Valor de los regalos con descuento

     El campo `discount` del metaobjeto es un porcentaje. Cuando viene lleno,
     al valor del regalo se le suma ese porcentaje del precio de compra única.
     Ese precio cambia con la variante y con la porción, así que el cálculo
     tiene que vivir aquí y no en Liquid.
  ---------------------------------------------------------------- */

  /*
    Se lee el importe ya pintado en vez de recalcularlo desde el JSON del
    producto, porque otros scripts del PDP (syncStayAiPrice) pueden reescribir
    ese precio y lo que el usuario ve es la referencia correcta.

    El separador decimal se detecta por posición —un punto o una coma seguidos
    de exactamente dos dígitos al final— así que funciona igual con
    "$ 749.00 MXN" que con "659,12 MXN".
  */
  function parseMoneyToCents(text) {
    if (!text) return null;

    var limpio = String(text).replace(/[^\d.,]/g, '');
    if (!limpio) return null;

    var decimales = limpio.match(/[.,](\d{2})$/);
    if (decimales) {
      var entero = limpio.slice(0, limpio.length - 3).replace(/[.,]/g, '');
      return parseInt(entero || '0', 10) * 100 + parseInt(decimales[1], 10);
    }

    return parseInt(limpio.replace(/[.,]/g, ''), 10) * 100;
  }

  // Mismo formato que usa Liquid: el string viene del shop en la config.
  function formatMoney(cents, format) {
    var plantilla = format || '${{amount}}';
    var token = plantilla.match(/\{\{\s*(\w+)\s*\}\}/);
    var nombre = token ? token[1] : 'amount';

    var negativo = cents < 0;
    var abs = Math.abs(Math.round(cents));

    var sepMiles = ',';
    var sepDecimal = '.';
    if (nombre.indexOf('comma_separator') !== -1) {
      sepMiles = '.';
      sepDecimal = ',';
    } else if (nombre.indexOf('apostrophe_separator') !== -1) {
      sepMiles = "'";
    }

    var sinDecimales = nombre.indexOf('no_decimals') !== -1;
    var entero = sinDecimales
      ? Math.round(abs / 100).toString()
      : Math.floor(abs / 100).toString();
    var decimales = ('0' + (abs % 100)).slice(-2);

    entero = entero.replace(/(\d)(?=(\d{3})+$)/g, '$1' + sepMiles);

    var valor = sinDecimales ? entero : entero + sepDecimal + decimales;
    return (negativo ? '-' : '') + plantilla.replace(token ? token[0] : '{{amount}}', valor);
  }

  function onetimePriceCents() {
    var host = document.querySelector('[data-stayai-onetime-price]');
    if (!host) return null;

    var span = host.querySelector('span');
    return parseMoneyToCents((span || host).textContent);
  }

  function refreshGiftValues() {
    var nodos = document.querySelectorAll('[data-ab-gift-discount]');
    if (!nodos.length) return;

    var base = onetimePriceCents();
    if (base === null) return;

    Array.prototype.forEach.call(nodos, function (nodo) {
      var porcentaje = parseFloat(nodo.getAttribute('data-ab-gift-discount')) || 0;
      var propio = parseInt(nodo.getAttribute('data-ab-gift-base') || '0', 10) || 0;
      var total = propio + Math.round((base * porcentaje) / 100);

      var destino = nodo.querySelector('[data-ab-gift-amount]');
      if (!destino) return;

      var texto = formatMoney(total, WIDGET_CFG && WIDGET_CFG.moneyFormat);
      // Escribir solo si cambia: el MutationObserver observa el <body> y una
      // escritura incondicional lo haria dispararse en bucle.
      if (destino.textContent !== texto) destino.textContent = texto;
    });
  }

  /* ----------------------------------------------------------------
     Cupón de la primera entrega

     El encabezado de la variante B promete "+ 25% OFF en tu primer entrega",
     así que el cupón se tiene que aplicar de verdad. Portado de la prueba
     subscription-frontend-discount (commit d530f7c).
  ---------------------------------------------------------------- */

  /*
    Se aplica al ENTRAR a la variante B, no al agregar al carrito. La cookie de
    descuento tiene que existir antes del /cart/add: si se pone despues, las
    secciones de carrito que Shopify ya devolvio vienen sin el descuento y no se
    ve en el drawer hasta la siguiente actualizacion.
  */
  function initDiscount() {
    if (!WIDGET_CFG) return;

    var code = WIDGET_CFG.discountCode;
    if (!code) return;

    /*
      Se pregunta por el estado real del carrito en vez de guardar una bandera
      propia. Con bandera, si algo mas quitaba el cupon, la bandera seguia
      puesta y la variante B ya nunca lo volvia a aplicar. Asi se corrige solo,
      y ante la duda aplica de mas — que es inofensivo — en vez de de menos.
    */
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        var applied =
          cart &&
          (cart.discount_codes || []).some(function (discount) {
            return (discount.code || '').toUpperCase() === code.toUpperCase();
          });

        if (applied) return;

        // Se redirige a /cart.js para no arrastrar el HTML completo de la home.
        return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
          credentials: 'same-origin'
        });
      })
      .catch(function () {
        /* sin red: se vuelve a intentar en la siguiente carga */
      });
  }

  /* ----------------------------------------------------------------
     Arranque
  ---------------------------------------------------------------- */

  function start() {
    // Primero el cupon: entre menos tarde la cookie, menos probable es que el
    // usuario alcance a dar Agregar al carrito antes de que este puesta.
    initDiscount();
    rewriteWidget();
    placeAll();
    refreshGiftValues();

    var pending = null;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = window.setTimeout(function () {
        pending = null;
        rewriteWidget();
        placeAll();
        refreshGiftValues();
      }, 200);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // rtx-pdp.js reescribe el % de ahorro al cambiar de plan o de variante.
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('.stayai-subscriptions, product-info')) {
        window.setTimeout(function () {
          rewriteWidget();
          refreshGiftValues();
        }, 60);
      }
    });

    // Red de seguridad del CSS anti-flash: si el widget nunca se renderiza,
    // se libera igual para no dejarlo invisible.
    window.setTimeout(function () {
      document.body.classList.add(READY_CLASS);
    }, 5000);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });

    // El número de tarjetas por página cambia en el breakpoint de 750px.
    window.addEventListener('resize', function () {
      if (renderModalPage) renderModalPage();
    });
  }

  function boot() {
    whenActivated(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
